import { jsonldLatitude } from './JsonldStore';

export const updateJsonldLatitude = (value) => jsonldLatitude.update((oldValue) => value);
